// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary_summary__-t8Yp","point":"summary_point__3htAQ","score":"summary_score__2SShl","badge":"summary_badge__1wYp5"};